import { useAtomSet, useAtomValue } from "@effect-atom/atom-react";
import { clawInstallModeAtom, nextClawInstallMode, persistClawInstallMode } from "~/lib/atoms/clawinstall-theme.ts";

/**
 * Light/dark toggle for the ClawInstall property. Flips
 * {@link clawInstallModeAtom} (which the layout mirrors to `data-mode`) and
 * persists the choice — an explicit toggle thus overrides the OS preference.
 *
 * @since 1.0.0
 */
export function ClawInstallThemeToggle({ className }: { readonly className?: string }) {
  const mode = useAtomValue(clawInstallModeAtom);
  const setMode = useAtomSet(clawInstallModeAtom);
  const next = nextClawInstallMode(mode);

  return (
    <button
      type="button"
      aria-label={`Switch to ${next} mode`}
      data-testid="clawinstall-theme-toggle"
      onClick={() => {
        setMode(next);
        persistClawInstallMode(next);
      }}
      className={className
        ?? "flex h-10 w-10 items-center justify-center rounded-md border border-outline-variant bg-surface text-on-surface-variant transition-colors hover:bg-surface-variant hover:text-on-surface"}
    >
      <span className="material-symbols-outlined !text-xl">
        {mode === "dark" ? "light_mode" : "dark_mode"}
      </span>
    </button>
  );
}
